<template>
  <div class="interval-menu" :class="{disabled: disabled}">
    <div class="title">
      <span>{{num}}</span>
      <span class="tri"></span>
    </div>
    <div class="content" :style="{display: disabled ? 'none' : ''}">
      <ul>
        <li
          v-for="(item, i) in items"
          @click="clickItem(item, i)"
          :key="i"
        >{{item.value}}</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    num: { type: Number, default: 5 },
    disabled: {type: Boolean, default: false}
  },
  data () {
    return {
      items: [
        { value: 30 },
        { value: 25 },
        { value: 20 },
        { value: 15 },
        { value: 10 },
        { value: 5 },
      ]
    }
  },
  methods: {
    clickItem (item, i) {
      this.$emit('clickItem', { item, index: i });
    }
  }
}
</script>

<style lang="scss" scoped>
.interval-menu {
  position: relative;
  width: 46px;
  cursor: pointer;
  &.disabled {
    cursor: not-allowed;
  }
  &:hover {
    & > .content {
      display: block;
    }
  }
}
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 46px;
  height: 30px;
  background: #ffffff;
  border: 1px solid #dadeea;
  border-radius: 4px;
  padding: 7px;
}
.content {
  display: none;
  position: absolute;
  bottom: 100%;
  left: 0;
  width: 100%;
  padding-bottom: 4px;
  & > ul {
    width: 46px;
    height: 120px;
    background: #ffffff;
    box-shadow: 1px 1px 2px 2px #747ca833;
    border-radius: 4px;
    overflow: hidden;
    & > li {
      font-size: 12px;
      height: 20px;
      line-height: 20px;
      &:hover {
        background: #ebedf3;
      }
    }
  }
}
.tri {
  border-bottom: 6px solid #484262;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top-width: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/versionControl/intervalMenu.vue